import { render, staticRenderFns } from "./CreateStudy.vue?vue&type=template&id=c29b62ba&scoped=true&"
import script from "./CreateStudy.vue?vue&type=script&lang=js&"
export * from "./CreateStudy.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudy.vue?vue&type=style&index=0&id=c29b62ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29b62ba",
  null
  
)

export default component.exports